import { NgModule } from '@angular/core';

import { SharedDependenciesModule } from '../../shared';

import { TemperatureSelectComponent } from './components/temperature-select/temperature-select.component';
import { TemperatureUnitPipe } from './pipes/temperature-unit/temperature-unit.pipe';

@NgModule({
  imports: [SharedDependenciesModule],
  declarations: [TemperatureUnitPipe, TemperatureSelectComponent],
  exports: [TemperatureUnitPipe, TemperatureSelectComponent],
  providers: [TemperatureUnitPipe],
})
export class TemperatureModule {}
